import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Select, Tag, DatePicker, Tooltip, Spin, Pagination, Button, Input } from 'antd';
import { WarningOutlined } from '@ant-design/icons';
import gestionXml from '../../Actions/gestionXml';
import user from '../../Actions/user';
import { DefaultfilteredDownloadsPagination } from '../../Reducers/gestionXml';
import Base from '../Base';
import ServiceHealthWarning from '../ServiceHealthWarning';
import moment from 'moment';
import TableView from '../tableView';
import Download from '../download';
import DashboardButton from '../dashboardButton';
import { getStatusColor, renderStatusCell } from '../../helpers';
import {pageGA } from '../../Helpers/GoogleAnalytics';
import { sortByDate, sortByString, sortStringByKey } from '../../Helpers/TableSorter';
import { orderListByKey} from '../../helpers';
import { getFilterByColumnValue } from '../../Helpers/PortalHelpers';
import Dashboard from '../Dashboard';
import dashboard from '../../Actions/dashboard';
const { Option } = Select;
const { getFilteredDownloadedFiles, getZipFromPath, updateFilteredDownloadsPagination, setFilteredData } = gestionXml.actions;
const { showDashboard, getDashboardData } = dashboard.actions;
const { getUserData } = user.actions;
const { RangePicker } = DatePicker;

class Settings extends Component {
	constructor() {
		super();
		this.actions = this.actions.bind(this);
		this.getZipFromPath = this.getZipFromPath.bind(this);
		this.updateRecords = this.updateRecords.bind(this);
		this.searchRequests = this.searchRequests.bind(this);
		this.changeDatesRange = this.changeDatesRange.bind(this);
		this.cleanFilters = this.cleanFilters.bind(this);
		this.handleInputChange = this.handleInputChange.bind(this);
		this.state = {
			selectedFilterOption: 0,
			typeOptions: [			
				{label: 'Web Service', value: 0,},
				{label: 'Portal del SAT', value: 1},
				{label: 'Validación EFOS', value: 2},
				{label: 'Web Service con fecha de cancelación', value: 3},
			],
			statusOptions: [
				{label: 'Todas', value: -1},
				{label: 'En Progreso', value: 1},
				{label: 'Completadas', value: 6},
				{label: 'Error', value: 3},
			]
		};
	}

	componentDidMount() {		
		this.props.getUserData({page:1, perPage: 200, isFiltered: true});	 
		this.props.getFilteredDownloadedFiles(this.props.downloadsPagination); 
		pageGA();
	}

	render() {
		const { page, perPage, totalCount, taxId, documents, type, status, startDate, endDate, taxIdIssuer } = this.props.downloadsPagination;
		
		return (
			<Base>
				<ServiceHealthWarning />
				<Dashboard />
				<h1 className="title-text blue-text">Estatus de Solicitudes</h1>
				<div className="filters-container">
					<div className="input-container">
						<label htmlFor="" className="label">RFC de descarga:</label>
						<Select
							defaultValue=''
							value={taxId}
							style={{ width: 160 }}
							onChange={this.handleChangeFilterBy.bind(this, 'taxId')}
							showSearch
							allowClear
							onClear={this.handleClearTaxId.bind(this)}
							onSearch={this.handleSearchTaxId.bind(this)}
							loading={this.props.taxIdSearchLoading}	
						>
							<Option value=''>
								Todos
							</Option>
							{
							orderListByKey(this.props.userData, "taxId").map((element, index) => (
								<Option key={index} value={element.taxId}>
									{element.taxId}
								</Option>
							))}

						</Select>
					</div>
					<div className="input-container">
						<label htmlFor="" className="label">Documentos:</label>
						<Select
							defaultValue={documents}
							value={documents}
							style={{ width: 120 }}
							onChange={this.handleChangeFilterBy.bind(this, 'documents')}
						>
							<Option value="Todos">Todos</Option>
							<Option value="Emision">Emisión</Option>
							<Option value="Recepcion">Recepción</Option>
						</Select>
					</div>
					
					<div className="input-container">
						<label htmlFor="" className="label">Tipo de Descarga:</label>
						<Select
								defaultValue={type}
								value={type}
								style={{ width: 160 }}
								onChange={this.handleChangeFilterBy.bind(this, 'type')}
							>
								{
									this.state.typeOptions.map((element) => {
										return (
											<Option key={element.value} value={element.value}>
												{element.label}
											</Option>
										);
									})}
							</Select>
					</div>
					<div className="input-container">
						<label htmlFor="" className="label">Estatus:</label>
						<Select
								defaultValue={status}
								value={status}
								style={{ width: 160 }}
								onChange={this.handleChangeFilterBy.bind(this, 'status')}
							>
								{
									this.state.statusOptions.map((element, index) => {
										return (
											<Option key={index} value={element.value}>
												{element.label}
											</Option>
										);
									})}
							</Select>
					</div>
					<div className="input-container">
						<label htmlFor="" className="label block">Rango de fechas:</label>
						<RangePicker
							value={(startDate  === '' || endDate  === ''  ? '' : [moment(startDate, 'MM-DD-YYYY'), moment(endDate, 'MM-DD-YYYY')])}
							style={{ width: 230 }}
							format="MM-DD-YYYY"
							onChange={this.changeDatesRange.bind(this)}
						/>
					</div>
					<div className="input-container">
						<label htmlFor="" className="label block">RFC proveedor</label>
						<Input 
							placeholder="RFC" 
							style={{width:'170px'}} 
							value={taxIdIssuer} 
							onChange={this.handleInputChange}
							disabled={![0, 3].includes(type) || documents !== 'Recepcion'}
						/>
					</div>
					<div className="input-container-inline" style={{flex:1, display: 'flex',justifyContent: 'flex-end', alignItems:'flex-end'}}>
						<Button onClick={this.cleanFilters} style={{marginRight: '10px'}}>Limpiar</Button>
						<Button type={'primary'} onClick={this.searchRequests}>Buscar</Button>
					</div>
				</div>
				<TableView 
					loading={this.props.tableLoading} 
					columns={this.actions()}
					data={this.props.downloadsRequested} 
				/>
					<Pagination
						total={totalCount}
						showTotal={total => `Total ${total}  registros`}
						pageSize={perPage}
						defaultCurrent={1}
						current={page}
						showSizeChanger={false}
						onChange={this.updateRecords}
					/>
				{((!this.props.tableLoading && !this.props.taxIdSearchLoading) && this.props.isLoading) &&
					<div className="loading-container">
						<Spin size="large" tip="Cargando" />
					</div>
				}
			</Base>

		);
	}
	
	rowAction(record, e) {	
		if (record.requestType !== 'Validación EFOS' && record.statusRequest && record.statusRequest[0] === 'Completado') {
			this.props.getDashboardData(record.requestId);
			this.props.showDashboard(true);
		}
	}

	updateRecords(page, pageSize) {
		const query = {
			...this.props.downloadsPagination,
			page
		};
		this.props.getFilteredDownloadedFiles(query); 
	}

	getZipFromPath(filePath, event) {
		if (filePath)
			this.props.getZipFromPath(filePath);
		event.stopPropagation();
	}

	searchRequests() {		
		const data = {
			...this.props.downloadsPagination,
			page:1
		}		
		this.props.getFilteredDownloadedFiles(data); 
	}

	changeDatesRange(dates, dateStrings) {		
		this.props.setFilteredData({ startDate: dateStrings[0], endDate: dateStrings[1] });
	}

	handleChangeFilterBy(key, value) {
		this.props.setFilteredData({[key]: value});
	}

	handleSearchTaxId(value) {
		this.populateTaxIdData(value);
	}

	handleClearTaxId() {
		this.populateTaxIdData('');
	}

	populateTaxIdData(value) {
		this.props.getUserData({
			...this.props.certificatesPagination,
			page: 1,
			perPage: 200,
			filter: value,
			isFiltered: true
		});
	}

	handleInputChange(e) {
		this.props.setFilteredData({ taxIdIssuer: e.target.value.toUpperCase() });
	}

	cleanFilters() {
		this.props.setFilteredData({...DefaultfilteredDownloadsPagination()});		
		this.props.getFilteredDownloadedFiles({...DefaultfilteredDownloadsPagination()});
	}

	actions() {
		let columns = [
			{
				title: 'Registro',
				dataIndex: 'createdDate',
				key: 'createdDate',
				sorter: (a, b) => sortByDate(a, b, 'createdDate'),
				sortDirections: ['descend', 'ascend']
			},
			{
				title: 'RFC',
				dataIndex: 'taxId',
				key: 'taxId',
				sorter: (a, b) => sortStringByKey(a, b, 'taxId'),
				sortDirections: ['descend', 'ascend']
			},
			{
				title: 'Rango de fechas',
				key: 'date',
				render: (tex, row) => (
					<span>{row.dateFrom} - {row.dateTo}</span>
				),
				sorter: (a, b) => sortByDate(a, b, 'dateFrom'),
				sortDirections: ['descend', 'ascend']
			},
			{
				title: 'Tipo de documentos',
				dataIndex: "document",
				render: (tex, row) => (
					<span>{row.documentType}</span>
				),
				sorter: (a, b) => sortStringByKey(a, b, 'documentType'),
				sortDirections: ['descend', 'ascend'],
			},
			{
				title: 'Tipo de descarga',
				dataIndex: "requestType",
				key: 'requestType',
				sorter: (a, b) => sortStringByKey(a, b, 'requestType'),
				sortDirections: ['descend', 'ascend'],
			},
			{
				title: 'Estatus',
				dataIndex: 'statusRequest',
				key: 'statusRequest',
				render: (text, row) => renderStatusCell(row.statusRequest, row.totalFiles),
				sorter: (a, b) => {
					return sortByString(a.statusRequest[0], b.statusRequest[0]);
				},
				sortDirections: ['descend', 'ascend'],
			},
			{
				title: 'Relación con EFOS',
				dataIndex: 'efosIndicator',
				key: 'efosIndicator',
				render: efosIndicator => {
					if(efosIndicator === 1) {
						return (
							<Tooltip title='Encontramos xml relacionados con EFOS en esta solicitud'>
								<WarningOutlined 
									style={{ fontSize: '20px', color: '#ffc70d' }}
								/>
							</Tooltip>
						);
					}
					return '-'
				},
				sorter: (a, b) => {
					return sortStringByKey(a, b, 'efosIndicator');
				},
				sortDirections: ['descend', 'ascend'],
			},
			{
				title: 'Filtro',
				dataIndex: "filterBy",
				key: 'filterBy',
				render: (text, row) => {
					return <span>{getFilterByColumnValue(row)}</span>
				},
				sorter: (a, b) => {
					const one = getFilterByColumnValue(a);
					const two = getFilterByColumnValue(b);
					return sortByString(one, two); 
				},
				sortDirections: ['descend', 'ascend'],
			},
			{
				title: "",
				key: 'action',
				render: (text, row) => (
					<div style={{ display: 'flex', alignItems: 'center' }}>
					{
						row.processes.map((report, index) => {
							return (
								<Download download={this.getZipFromPath} key={index} pos={index} report={report} />
							)
						})
						
					}
					{
						row.requestType !== 'Validación EFOS' &&
							<DashboardButton handleClic={this.rowAction.bind(this, row)} row={row}/>
					}
					</div>
				)
			}
		];
		return columns;
	}
}

const mapStateToProps = state => {
	let tableLoader = state._genericComponents.loading.find('tableLoading');
	let TaxIdSearchLoader = state._genericComponents.loading.find('taxIdSearchLoading');

	return {
		downloadsRequested: state.gestionXml.filteredDownloadsRequested,
		tableLoading: tableLoader ? tableLoader.isLoading : false,
		downloadXmls: state.gestionXml.downloadXmls,
		taxIdSearchLoading: TaxIdSearchLoader ? TaxIdSearchLoader.isLoading : false,
		isLoading: state._genericComponents.loading.isCurrentlyLoading,
		userData: state.user.userData,
		downloadsPagination: state.gestionXml.filteredDownloadsPagination
	};
};

const mapDispatchToProps = dispatch => {

	return {
		getFilteredDownloadedFiles(query) {
			dispatch(getFilteredDownloadedFiles(query));
		},
		getZipFromPath(filePath) {
			dispatch(getZipFromPath(filePath));
		},
		updateFilteredDownloadsPagination(data) {
			dispatch(updateFilteredDownloadsPagination(data));
		},
		showDashboard(state) {
			dispatch(showDashboard(state));
		},
		getDashboardData(data) {
			dispatch(getDashboardData(data));
		},
		setFilteredData(data) {
			dispatch(setFilteredData(data));
		},
		getUserData(query) {
			dispatch(getUserData(query));
		}
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(Settings);